var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_599_4630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1211 10.582C12.7539 9.67188 13.125 8.57031 13.125 7.375C13.125 4.26953 10.6055 1.75 7.5 1.75C4.39453 1.75 1.875 4.26953 1.875 7.375C1.875 8.57031 2.24609 9.67188 2.87891 10.582C3.03906 10.8125 3.22266 11.0625 3.41016 11.3242C3.90625 12.0078 4.46875 12.7773 4.89453 13.5547C5.24219 14.1875 5.42969 14.8555 5.52734 15.5039H4.25781C4.17188 15.0352 4.02734 14.5781 3.79688 14.1562C3.41016 13.4531 2.92969 12.793 2.44922 12.1328C2.24609 11.8555 2.04297 11.5781 1.84766 11.2969C1.07812 10.1836 0.625 8.83203 0.625 7.375C0.625 3.57812 3.70312 0.5 7.5 0.5C11.2969 0.5 14.375 3.57812 14.375 7.375C14.375 8.83203 13.9219 10.1836 13.1484 11.293C12.9531 11.5742 12.75 11.8516 12.5469 12.1289C12.0664 12.7852 11.5859 13.4453 11.1992 14.1523C10.9688 14.5742 10.8242 15.0312 10.7383 15.5H9.47266C9.57031 14.8516 9.75781 14.1836 10.1055 13.5508C10.5312 12.7695 11.0938 12 11.5898 11.3203C11.7813 11.0586 11.9609 10.8125 12.1211 10.5781V10.582ZM7.5 4.25C5.77344 4.25 4.375 5.64844 4.375 7.375C4.375 7.71875 4.09375 8 3.75 8C3.40625 8 3.125 7.71875 3.125 7.375C3.125 4.95703 5.08203 3 7.5 3C7.84375 3 8.125 3.28125 8.125 3.625C8.125 3.96875 7.84375 4.25 7.5 4.25ZM5.73047 18C5.98828 18.7266 6.68359 19.25 7.5 19.25C8.31641 19.25 9.01172 18.7266 9.26953 18H5.73047ZM4.375 17.375V17.168C4.375 16.9375 4.5625 16.75 4.79297 16.75H10.207C10.4375 16.75 10.625 16.9375 10.625 17.168V17.375C10.625 19.1016 9.22656 20.5 7.5 20.5C5.77344 20.5 4.375 19.1016 4.375 17.375Z",
    fill: "#707070"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_599_4630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.bc87132301ea0a39a95aff3ab9b2ae08.svg";
export { ForwardRef as ReactComponent };